import { Id } from '../aliases'
import { ReauthNeededInfo } from '../types'
import { uint8ToUrlBase64 } from '../utils'

export class ReauthNeededInfoSaver {
  readonly reauthNeededInfoKey = 'reauthNeededInfo'

  saveReauthNeededInfo(hasMeshfaClient?: boolean, humanProxyId?: Id) {
    const path = window.location.pathname

    const reauthNeededInfo: ReauthNeededInfo = {
      path,
      hasMeshfaClient,
      humanProxyId: humanProxyId ? uint8ToUrlBase64(humanProxyId) : undefined,
    }

    console.log('Saving reauth needed info:', JSON.stringify(reauthNeededInfo))

    localStorage.setItem(
      this.reauthNeededInfoKey,
      JSON.stringify(reauthNeededInfo),
    )
  }

  clearReauthNeededInfo() {
    localStorage.removeItem(this.reauthNeededInfoKey)
  }
}
